import { globalValues } from './variables';

var CryptoJS = require("crypto-js");
var CryptoJSAesJson = {
    stringify: function (cipherParams) {
        var j = {ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)};
        if (cipherParams.iv) j.iv = cipherParams.iv.toString();
        if (cipherParams.salt) j.s = cipherParams.salt.toString();
        return JSON.stringify(j);
    },
    parse: function (jsonStr) {
        var j = JSON.parse(jsonStr);
        var cipherParams = CryptoJS.lib.CipherParams.create({ciphertext: CryptoJS.enc.Base64.parse(j.ct)});
        if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
        if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
        return cipherParams;
    }
}


const cryptoEncrypt = (data = '') => {
    // var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), globalValues.DATA_ENC_KEY)
    return CryptoJS.AES.encrypt(JSON.stringify(data), globalValues.DATA_ENC_KEY, {format: CryptoJSAesJson}).toString();

}
export default cryptoEncrypt;



